import { PRICE_TYPES } from "../../constants/custom-define-type";
import axios from "axios";

const state = {
  priceList: null, // list prices of price manager
  rushFeeInfo: null // Save rush fee of repeated bookings (when rush fee of each booking can be different)
};

const mutations = {
  setPriceList(state, payload) {
    state.priceList = payload;
  },
  setRushFeeInfo(state, payload) {
    state.rushFeeInfo = payload;
  },
};

const actions = {
  loadPriceList({ commit, state, rootState }) {
    return new Promise(async (resolve) => {
      if (state.priceList) {
        resolve();
        return;
      }
      const res = await axios.get(
        "/api/prices/?agency=" +
        rootState.authentication.agencyID.toString()
      );
      commit("setPriceList", res.data.filter(item => !item.deactivated));
      resolve();
    });
  },
  setPriceList({ commit }, payload) {
    commit("setPriceList", payload);
  },
  setRushFeeInfo({ commit }, payload) {
    commit("setRushFeeInfo", payload);
  },
};

const getters = {
  priceList(state) {
    return state.priceList || [];
  },
  hourlyServiceSelectionList(state) {
    if (!state.priceList) {
      return [];
    }
    let result = state.priceList.filter(
      (price) => price.type === PRICE_TYPES.HOURLY_SERVICES_SELECTION
    );
    // Sort by order (null items at the end)
    result = result.sort((item1, item2) => (item2.order != null) - (item1.order != null) || item1.order - item2.order);
    result.forEach(
      (price) => {
        let label = price.name;
        if (price.price2) {
          label = `${label}, $${price.price2} per hour`;
        }
        price.label = label;
      }
    );
    return result;
  },
  quickbooksPriceSelectionList(state) {
    if (!state.priceList) {
      return [];
    }
    let result = state.priceList.filter(
      (price) => price.type === 'Quickbooks Desktop'
    );
    // Sort by order (null items at the end)
    result = result.sort((item1, item2) => (item2.order != null) - (item1.order != null) || item1.order - item2.order);
    return result;
  },
  turnOnSurgePricing(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.turn_on_surge_price;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  isRecalculatePriceOnAssignJob(state) {
    if (!state.priceList) {
      return false;
    }
    // Recalculate if price depends on candidate
    return state.priceList.some(price => price.is_price_expession && price.price_expression && (price.price_expression.includes('[[filler_number_job_in_month]]') || price.price_expression.includes('[[candidate_rate]]')))
  },
  listModelRecalculatedWhenAssignJob(state) {
    if (!state.priceList) {
      return [];
    }
    let result = [];
    const listRecalculatePrices = state.priceList.filter(price => price.is_price_expession && price.price_expression && (price.price_expression.includes('[[filler_number_job_in_month]]') || price.price_expression.includes('[[candidate_rate]]')));
    for (const price of listRecalculatePrices) {
      if (price.type === PRICE_TYPES.HOURLY_AGENCY_COMMISSION) {
        result.push('agency_fee');
      }
      if (price.type === PRICE_TYPES.HOURLY_BOOKING_RATE) {
        result.push('candidate_rate');
        result.push('client_rate');
      }
    }
    return result;
  },
  rushFeeInfo(state) {
    return state.rushFeeInfo;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/prices.js